import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { withTranslation, useTranslation } from 'react-i18next';

function NewEdmLayout(props) {
    const { component: Component, path, ...rest } = props;

    return (
        <EmailOutline>
            <Helmet>
                <meta charset="UTF-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
                <body width="100%" style={{
                    "background-color": "#f5f5f5", 
                    padding: "50 50 50",
                    margin: "30",
                    "fontFamily": "微軟正黑體",
                    color: "#000000"
                }}/>
            </Helmet>
            
            <Component {...rest}/>            
        </EmailOutline>
    );
}

function EmailOutline(props) {
    return (
        <table width="100%" bgcolor="#ffffff" border="0" cellSpacing="0" cellPadding="0" style={{
            width: "100%",
            margin: "auto",
            border: "0px",
            "borderSpacing": "0px",
            "maxWidth": "650px",
            "minWidth": "320px"
        }}><tbody>
            <tr>
                <td>
                    <table bgcolor="#FFFFFF" width="100%" cellSpacing="0" cellPadding="0" border="0" style={{
                        padding: "10 10 15px"
                    }}>
                        <tbody>
                            <tr>
                                <td bgcolor="#ffffff" style={{
                                    "textAlign": "left",
                                    padding: "40px",
                                    margin: "10px"
                                }}>
                                    <EmailHeader/>
                                    {props.children}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <EmailFooter/>
        </tbody></table>
    );
}

function EmailHeader(props) {
    const SFC_DOMAIN = `${process.env['REACT_APP_SFC_DOMAIN']}`;    
    return (
        <a href="" target="_blank">
            <img src={`//${SFC_DOMAIN}/assets/images/common/logo.svg`} alt="" width="135" border="0" style={{
                "maxWidth": "100%",
                width: "206px",
                display: "block"
            }}/>
        </a>
    ); 
}

function EmailFooter(props) {
    const { t } = useTranslation();

    return (
        <tr>
            <td bgcolor="#0e948b" align="center" style={{
                color: "#ffffff",
                "textAlign": "center",
                padding: "0 14px",
                "fontSize": "12px",
                "fontFamily": "微軟正黑體",
                padding: "20px 10px"  
            }}>
                Please do not reply to this email. Change/unsubscribe | Privacy Policy<br/>
                請勿回覆此電郵。 更改／取消訂閱 | 私隱政策聲明<br/>
                {t('common:address',{lng:"EN",dummy:"123"})}<br />
                {t('common:address',{lng:"TC",dummy:"123"})}
            </td>
        </tr>
    ); 
}

export default withTranslation()(NewEdmLayout);